<template>
  <!-- 公众号群信息 -->
  <div class="wechatMsg">
    <div class="nodeTitle">微信群消息</div>
    <div class="title">
      <span></span>内容
    </div>
    <el-input type="textarea" :rows="5" v-model="node.content" placeholder="请输入内容"></el-input>
    <el-upload
      action="#"
      class="upload-box"
      ref="upload"
      list-type="picture-card"
      :auto-upload="true"
      :limit="1"
      :on-exceed="handleExceed"
      accept=".jpg, .jpeg, .png, .gif"
      :file-list="showFiles"
      :http-request="uploadPic"
      :before-upload="beforeAvatarUpload"
    >
      <el-button type="primary" class="uploadBtn">
        <i class="iconfont icon-yunshangchuan"></i>
        上传图片
      </el-button>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
  </div>
</template>

<script>
/* eslint-disable */
import {
  uploadFile,
} from "@/service/group";
import { Message } from "element-ui";
export default {
  props: ["editnode"],
  data() {
    return {
      node: {
        content: "",
        msgId: "",
      },
      showFiles: [],
      disable: false,
      upload: {
        file: null,
        type: "image",
        introduction: "素材介绍"
      }
    };
  },
  mounted() {},
  created() {
  },
  watch: {
    editnode(val) {
      console.log("wewe-> val", val);
      this.init(val);
    }
  },
  methods: {
    handleRemove(file) {
      this.$refs.upload.clearFiles();
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 上传文件超出个数
    handleExceed(files, fileList) {
      Message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    async uploadPic(val) {
      this.upload.file = val.file;
      this.disable = true;
      uploadFile({ ...this.upload }).then(res => {
        Message.success("图片上传成功");
        this.node.msgId = res;
        this.disable = false;
      });
    },
    save() {
      console.log("save -> this.node", this.node);
      if (this.node.content === "" || this.node.msgId === "") {
        Message.warning("请检查！配置项未填写完成！");
        return false;
      }
      return this.node;
    },
    init(val) {
      this.node = val || {
        content: "",
        msgId: ""
      };
    }
  }
};
</script>

<style lang="less">
.wechatMsg {
  .el-form-item {
    margin-bottom: 0px;
  }
  .disflexRow {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      display: inline-block;
      width: 5px;
      background: #eee;
      height: 18px;
      margin: 8px;
    }
  }
  .upload-box {
    display: flex;
    align-items: flex-start;
    margin: 8px;
    flex-direction: column;
    .el-upload-list__item {
      // margin-left: 20px;
    }

    .el-upload {
      background-color: #fff;
      width: auto;
      height: auto;
      line-height: 1;
      display: block;
      text-align: left;
      border: 0 !important;
      border-radius: 0;
      i {
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .el-textarea {
    margin: 8px;
    width: 80%;
  }
  .el-select,
  .el-radio {
    margin-bottom: 15px;
  }
}
</style>
